import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getEmployee, setDeleteEmployeeId, setUpdateEmployeeId} from "../../actions/employee";
import {Link, useHistory} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { usePermission } from '../../hooks/usePermission';
import { useManagerPermissions } from '../../hooks/useManagerPermissions';

const EmployeeItem = ({
                          setDeleteEmployeeId,
                          setUpdateEmployeeId,
                          getEmployee,
                          employee: {
                              id,
                              firm,
                              profession,
                              status,
                              first_name,
                              last_name,
                              inn,
                              address,
                              phone,
                              balance,
                              date: created_at
                          },
                          showActions,
                          number
                      }) => {

    const history = useHistory();
    const { userCan } = usePermission();
    const { canManagerEditEmployee, canManagerDeleteEmployee } = useManagerPermissions();
    
    // Reconstruct employee object for permission checking
    const employeeObject = {
        id,
        firm,
        profession,
        status,
        first_name,
        last_name,
        inn,
        address,
        phone,
        balance,
        date: created_at
    };

    const setDeleteEmployee = (id) => {
        setDeleteEmployeeId(id);
    };

    const setUpdateEmployee = (id) => {
        setUpdateEmployeeId(id);
    };

    if (!userCan('view employees')) {
        return null;
    }

    return (
        <tr>
            <th scope="row">{number}</th>
            <td>{first_name}</td>
            <td>{last_name}</td>
            <td>{inn}</td>
            <td>{address}</td>
            <td>{phone}</td>
            <td>{firm?.name}</td>
            <td>{profession}</td>
            {/*<td>{balance}</td>*/}
            <td>{status === 'hired' ? 'Ishlamoqda' : 'Ishdan ketgan'}</td>
            <td>
                <div className="d-flex gap-2">
                    {userCan('view employees') && (
                        <Link to={`employees/${id}`}>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                            >
                                <FontAwesomeIcon icon={faEye} />
                            </Button>
                        </Link>
                    )}
                    {canManagerEditEmployee(employeeObject) && (
                        <Button
                            variant="outline-primary"
                            size="sm"
                            className="d-flex align-items-center justify-content-center"
                            style={{ width: '32px', height: '32px', padding: 0 }}
                            onClick={() => setUpdateEmployee(id)}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </Button>
                    )}
                    {canManagerDeleteEmployee(employeeObject) && (
                        <Button
                            variant="outline-danger"
                            size="sm"
                            className="d-flex align-items-center justify-content-center"
                            style={{ width: '32px', height: '32px', padding: 0 }}
                            onClick={() => setDeleteEmployee(id)}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </Button>
                    )}
                </div>
            </td>
        </tr>
    );
};

EmployeeItem.defaultProps = {
    showActions: true,
};

EmployeeItem.propTypes = {
    employee: PropTypes.object.isRequired,
    setDeleteEmployeeId: PropTypes.func.isRequired,
    setUpdateEmployeeId: PropTypes.func.isRequired,
    getEmployee: PropTypes.func.isRequired,
    number: PropTypes.number,
    showActions: PropTypes.bool
};

export default connect(null, {setDeleteEmployeeId, getEmployee, setUpdateEmployeeId})(EmployeeItem);
